import { Navigate } from 'react-router-dom'
import { isAuthenticated } from '../services/auth'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Protected route component that redirects to login if not authenticated
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
